const _default = 10;

export default {
    timer: 0,
    default: _default,
    message: undefined,
}


// WEBPACK FOOTER //
// ./src/store/modules/alert/state.js